import { State } from './types'

export const initialState: State = {
  persistSchemaUpdated: 'initialState',
}

const reducer = (state = initialState): State => state

export default reducer
